/*!
 * Hero Video
 *
 * Dedicated background hero video block for app pages.
 * Uses explicit markup/styles so the overlay content cannot be hidden
 * by the shared ua.fs.video defaults.
 */

var _ = require("../../uam/module.js")(module.exports, {
  namespace: "hero.fs.video",
  title: "Hero Background Video",
  description: "Renders a full-screen background video with overlaid content.",
  fields: {
    src: {
      title: "Background Video",
      type: "uri",
      required: true,
      description: "MP4 source URL."
    },
    poster: {
      title: "Poster",
      type: "uri",
      required: true,
      description: "Poster image shown before playback."
    },
    inner: {
      title: "Inner",
      type: "inner",
      required: true,
      description: "Content layered on top of the video."
    },
    muted: {
      title: "Muted",
      type: "boolean",
      description: "Start muted so autoplay is allowed.",
      default: true
    },
    className: {
      title: "Class",
      type: "string",
      description: "Optional class names for the root wrapper."
    }
  },
  styling: {
    styles: [
      {
        selector: ".hero-fs-video",
        styles: [
          "position: relative;",
          "display: block;",
          "width: 100%;",
          "min-height: 100vh;",
          "max-height: 100vh;",
          "overflow: hidden;",
          "isolation: isolate;"
        ]
      },
      {
        selector: ".hero-fs-video-media-wrap",
        styles: [
          "position: absolute;",
          "inset: 0;",
          "width: 100%;",
          "height: 100%;",
          "z-index: 1;"
        ]
      },
      {
        selector: ".hero-fs-video-media",
        styles: [
          "position: absolute;",
          "inset: 0;",
          "width: 100%;",
          "height: 100%;",
          "object-fit: cover;",
          "object-position: center;"
        ]
      },
      {
        selector: ".hero-fs-video-overlay",
        styles: [
          "position: relative;",
          "z-index: 2;",
          "width: 100%;",
          "min-height: 100vh;",
          "padding-top: 5rem;",
          "padding-bottom: 4rem;",
          "display: flex;",
          "align-items: center;"
        ]
      }
    ]
  }
});

function generateInstanceId() {
  return "hero-fs-video-" + Math.floor(Math.random() * 1000000).toString(36) + "-" + Date.now().toString(36);
}

function safeBool(value, fallback) {
  if (typeof value === "boolean") {
    return value;
  }
  return fallback;
}

function safeText(value, fallback) {
  if (typeof value === "string") {
    return value;
  }

  if (value && value.toString) {
    return value.toString();
  }

  return fallback || "";
}

function isClientRender() {
  return (
    typeof window !== "undefined" &&
    typeof document !== "undefined" &&
    !window.UATisServer
  );
}

function ensureHeroPlayback(instanceId) {
  if (!(isClientRender())) {
    return;
  }

  var selector = "[data-hero-fs-video-id=\"" + instanceId + "\"] [data-hero-fs-video-media]";
  var media = document.querySelector(selector);

  if (!(media)) {
    return;
  }

  try {
    if (media.paused) {
      media.play().catch(function() {});
    }
  } catch (error) {
    // Safari/iOS and autoplay policies can block video playback.
    // No-op here; the background remains visible as poster if autoplay fails.
  }
}

var events = require("../../uam/events.js");
events.on("interface.afterrender", function() {
  var heroes = document.querySelectorAll("[data-hero-fs-video-id]");
  for (var i = 0; i < heroes.length; i++) {
    var heroId = heroes[i].getAttribute("data-hero-fs-video-id") || "";
    if (heroId) {
      ensureHeroPlayback(heroId);
    }
  }
});

exports.render = async function(options) {
  var instanceId = generateInstanceId();
  var rootClass = "hero-fs-video";
  if (typeof options.className === "string" && options.className.trim()) {
    rootClass = rootClass + " " + options.className.trim();
  }

  return {
    n: "section",
    c: rootClass,
    "data-hero-fs-video-id": instanceId,
    s: "position: relative; display: block; width: 100%; height: 100vh; min-height: 100vh; max-height: 100vh; overflow: hidden; isolation: isolate;",
    i: [
      {
        n: "div",
        c: "hero-fs-video-media-wrap",
        s: "position: absolute; inset: 0; width: 100%; height: 100%; z-index: 1;",
        i: {
          n: "video",
          c: "hero-fs-video-media",
          s: "position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; object-position: center center;",
          "data-hero-fs-video-media": "",
          autoplay: "",
          muted: safeBool(options.muted, true) ? "" : undefined,
          loop: "",
          playsinline: "",
          poster: safeText(options.poster),
          "aria-hidden": "true",
          "data-ua": "hero-fs-video-media",
          i: {
            n: "source",
            src: safeText(options.src),
            type: "video/mp4"
          }
        }
      },
      {
        n: "div",
        c: "hero-fs-video-overlay",
        s: "position: relative; z-index: 2; min-height: 100vh; width: 100%; padding-top: 4rem; padding-bottom: 4rem; display: flex; align-items: center;",
        i: {
          n: "div",
          c: "",
          s: "position: relative; z-index: 2;",
          i: options.inner
        }
      }
    ]
  };
};
